import '@/assets/scss/index.scss'
import Vue from 'vue'
import VueClipBoard from 'vue-clipboard2'
import _ from 'lodash'
import NaverMap from '@/components/common/NaverMap.vue'

import { commonfunc } from '~/mixin/common'

/**
 * packageName    : ms.msg
 * fileName       : SCR_MSG_0021
 * author         :
 * date           : 2023-08-28
 * description    : 판매매장상세
 * =============================================================
 * DATE             AUTHOR          NOTE
 * -------------------------------------------------------------
 * 2023-08-28       fekimsh         최초생성
 */
export default {
  components: {
    KakaoMap: NaverMap
  },
  mixins: [commonfunc],
  data () {
    return {
      outerVisible: false,
      strCd: null,
      shopStatus: null,
      str: {
        strNm: '',
        strZip: '',
        strAddr: '',
        strDtlAddr: '',
        opngTime: '',
        clsngTime: '',
        strTno: '',
        bassPkupStrYn: '',
        pkupYn: '',
        pntAcmYn: '',
        pntUseYn: '',
        elecRctwYn: '',
        parkYn: '',
        nmtkYn: '',
        phcYn: '',
        usimYn: '',
        phstkYn: '',
        nocashYn: '',
        sccardYn: '',
        sccashYn: '',
        elvtYn: '',
        entrRampYn: '',
        taxfYn: '',
        hflpYn: ''
      }
    }
  },
  watch: {
    outerVisible (val) {
      if (val) {
        this.$AxiosBuilder
          .data({ inclusiveStrCd: this.strCd })
          .build()
          .post('/ms/msg/selStr')
          .then((res) => {
            if (res.data.data && res.data.data.length) {
              this.str = this.convertStatusStore(res.data.data[0])
              this.reload()
            }
          })
      } else if (this.$refs.kakaoMap) {
        // 팝업 닫힐 때 지도 파괴
        this.$refs.kakaoMap.destroyMap()
      }
    },
    strCd (newVal, oldVal) {
      // 팝업이 열린 상태에서 매장코드가 바뀌면 새로 조회
      if (this.outerVisible && newVal && newVal !== oldVal) {
        this.$AxiosBuilder
          .data({ inclusiveStrCd: newVal })
          .build()
          .post('/ms/msg/selStr')
          .then((res) => {
            if (res.data.data && res.data.data.length) {
              this.str = this.convertStatusStore(res.data.data[0])
              this.reload()
            }
          })
      }
    }
  },
  mounted () {
  },
  methods: {
    copyAddr () {
      const fullAddr = this.str.strAddr + (this.str.strDtlAddr ? ' ' + this.str.strDtlAddr : '')
      VueClipBoard.config.autoSetContainer = true
      Vue.use(VueClipBoard)
      this.$copyText(fullAddr)
      this.$notify({
        message: '주소가 복사되었습니다.',
        position: 'bottom-left',
        showClose: false,
        duration: 5000,
        onClick: () => { this.$notify.closeAll() }
      })
    },
    callStr (strTno) {
      location.href = `tel:${strTno}`
    },
    // kakaoMap 컴포넌트 생성
    reload () {
      if (this.$refs.kakaoMap) {
        this.$refs.kakaoMap.destroyMap()
      }
      this.$nextTick(() => {
        setTimeout(() => {
          if (this.$refs.kakaoMap) {
            this.$refs.kakaoMap.create()
          }
        }, 500)
      })
    },
    convertStatusStore (item) {
      const currentTime = this.getCurrentTime()

      if (item && !_.isEmpty(item.opngTime) && !_.isEmpty(item.clsngTime) && _.isEmpty(item.hldyDt) && item.bsnSspYn !== 'Y') {
        item.opngTime = this.formatTime(item.opngTime)
        item.clsngTime = this.formatTime(item.clsngTime)
        if (currentTime >= item.opngTime && currentTime <= item.clsngTime) {
          return { ...item, status: 'status' }
        } else {
          return { ...item, status: 'off' }
        }
      } else if (item && (!_.isEmpty(item.hldyDt) || item.bsnSspYn === 'Y')) {
        item.opngTime = this.formatTime(item.opngTime)
        item.clsngTime = this.formatTime(item.clsngTime)
        return { ...item, status: 'close' }
      }

      return item
    },
    getCurrentTime () {
      const now = new Date()
      const hours = String(now.getHours()).padStart(2, '0')
      const minutes = String(now.getMinutes()).padStart(2, '0')
      return `${hours}:${minutes}`
    },
  }
}
